import type { UserState } from "$lib/stores/userStore"
import type { Competition } from "$lib/types/competition"

interface ReferralParams {
  user: UserState["user"]
  competition: Competition
  redirectUrl?: string
}

export async function getParentUrl(): Promise<string> {
  return new Promise((resolve) => {
    const messageHandler = (event: MessageEvent) => {
      if (event.data.type === "PARENT_URL_RESPONSE") {
        window.removeEventListener("message", messageHandler)
        resolve(event.data.url)
      }
    }
    window.addEventListener("message", messageHandler)
    window.parent.postMessage({ type: "REQUEST_PARENT_URL" }, "*")
  })
}

export async function generateReferralLink({
  user,
  competition,
  redirectUrl = window.location.href,
}: ReferralParams): Promise<string> {
  if (!user) {
    throw new Error("User info is missing")
  }

  let finalRedirectUrl = redirectUrl

  if (window.parent !== window) {
    // Check if in iframe
    try {
      finalRedirectUrl = await getParentUrl()
    } catch (error) {
      console.error("Error getting parent URL:", error)
    }
  }

  const cleanUrl = new URL(finalRedirectUrl)
  finalRedirectUrl = `${cleanUrl.origin}${cleanUrl.pathname.replace(/\/$/, "")}`

  const shouldUseCname =
    competition.cname &&
    competition?.cnameDetails?.status?.toLowerCase() === "active"

  const response = await fetch("/api/create-referral", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      participant_name: user.name,
      participant_email: user.email,
      competition_id: competition.id,
      // cname: shouldUseCname ? competition.cname : null,
      cname: competition.cname,
      redirect_url: finalRedirectUrl,
    }),
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.error || "Failed to generate referral link")
  }

  const data = await response.json()
  return data.referralLink
}
